import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { AdminInvoiceContextOperationsResponse } from './admin-invoice-context-operations.response';

@jsonObject
export class AdminOrderInvoiceResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly number!: string;

  @jsonMember(AdminInvoiceContextOperationsResponse)
  public readonly contextOperations!: AdminInvoiceContextOperationsResponse;
}
